import { action, observable, computed, toJS } from 'mobx';
import PagerStore from './utility/PagerStore';
import {
  SORT_AMOUNT, 
  SORT_CREATED,
  SORT_TERMINATED,
  SORT_ID,
  SORT_MACHINE,
  SORT_CLEANINGRATE,
  SORT_SUPPLIER,
  SORT_LOTNO,
  SORT_LOCATION,
  SORT_ITEM,
  SORT_QPURITY,
  SORT_QALIENSEED,
  SORT_QHARDSEED,
  SORT_QWATER
} from '../Containers/Table/Table'
import { formatDate } from 'utility.js'

const STORE_DATABASE = 'database';


class DatabaseStore {
  pager;
  configStore;

  constructor(rawState = {}, configStore) {
    this.configStore = configStore;
    this.pager = new PagerStore(rawState.pager);

    if (rawState.items) {
      this.setItems(rawState.items);
    }
    if (rawState.search) {
      this.setSearch(rawState.search);
    }
    if (rawState.sortField) {
      this.setSortField(rawState.sortField);
    }
    if (rawState.sortDirection) {
      this.setSortDirection(rawState.sortDirection);
    }
  }
  toJS() {
    return {
      items: toJS(this.items),
      search: toJS(this.search),
      pager: toJS(this.pager),
      sortField: toJS(this.sortField),
      sortDirection: toJS(this.sortDirection)
    };
  }

  @observable uploading = false;
  @action setUploading(value = true) {
    this.uploading = value;
  }

  @observable items = [];
  @action setItems(value) {
    this.items = value.map(item => {
      const name = this.configStore.items[item.ItemId];
      item.LotNo = parseInt(item.LotNo)
      item.QualityAlienseed = (item.QualityAlienseed == -1.0 ? 'Ny' : item.QualityAlienseed)
      item.ItemName = typeof name !== 'undefined' ? name : '-';
      item.Machine = this.configStore.machines[item.MachineId].Name + (item.CleaningCount ? ' x' + item.CleaningCount : '')
      item.CleaningRate = (this.configStore.cleaningRates[item.CleaningRate]).split('-')[0]
      item.Supplier = this.configStore.suppliers[item.SupplierId]
      item.Created = formatDate(item.Created)
      item.Terminated = (item.Terminated ? formatDate(item.Terminated) : '')
      item.FilterField = (
        item.LotNo + ' ' +
        (item.SealNum ? item.SealNum + ' ' : '') +
        item.Machine + ' ' +
        item.Supplier + ' ' +
        (item.CustomSupplier ? item.CustomSupplier + ' ' : '') +
        item.ItemName + ' ' +
        (item.CustomItem ? item.CustomItem + ' ' : '') +
        item.CleaningRate + ' ' + 
        (item.BinId ? item.BinId + ' ' : '') +
        item.Quantity + ' ' +
        (item.QualityPurity ? item.QualityPurity + ' ' : '') +
        (item.QualityAlienseed ? item.QualityAlienseed + ' ' : '' ) +
        (item.QualityHardseed ? item.QualityHardseed + ' ' : '') +
        (item.QualityWater ? item.QualityWater + ' ': '') +
        item.Created + ' ' +
        (item.Terminated ? item.Terminated + ' ' : '')
      ).toLowerCase()
      return item;
    });
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable from;
  @action setFrom(value) {
    this.from = value;
  }
  @computed get fromFormatted() {
    return formatDate(this.from);
  }

  @observable to;
  @action setTo(value) {
    this.to = value;
  }
  @computed get toFormatted() {
    return formatDate(this.to);
  }

  @observable showTerminated = false;
  @action changeShowTerminated() {
    this.showTerminated = !this.showTerminated;
  }

  @observable search = '';
  @action setSearch(value) {
    this.search = value;
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable sortField;
  @action setSortField(value) {
    this.sortField = value;
  }

  @observable sortDirection;
  @action setSortDirection(value) {
    this.sortDirection = value;
  }
  @action flipSortDirection() {
    this.sortDirection = this.sortDirection === SORT_ASC ? SORT_DESC : SORT_ASC;
  }

  @computed get filteredItems() {
    if (!this.search) {
      return this.items;
    }
    return observable(this.items.filter(item => {
      const searches = this.search.split(' ')
      for (let i = 0; i < searches.length; i++) {
        const s = searches[i].toLowerCase()
        //console.log(s, item.FilterField)
        if (item.FilterField.indexOf(s) === -1) {
          return false
        }
      }
      return true

      for (let fieldValue of Object.values(item)) {
        if (('' + fieldValue).indexOf(this.search) > -1) {
          return true;
        }
      }
      return false;
    }));
  }

  @computed get sortedItems() {
    if (!this.sortDirection || !this.sortField) {
      return this.filteredItems;
    }
    const sortedItems = [SORT_MACHINE, SORT_CLEANINGRATE, SORT_SUPPLIER, SORT_LOCATION, SORT_ITEM, SORT_CREATED, SORT_TERMINATED].indexOf(this.sortField) > -1 ?
      this.filteredItems.slice().sort((a, b) => {
        if(!a[this.sortField]) return -1
        if(!b[this.sortField]) return 1
        return a[this.sortField] ? a[this.sortField].localeCompare(b[this.sortField]) : -1;
      }) :
      this.filteredItems.slice().sort((a, b) => {
        const v1 = parseInt(a[this.sortField]);
        const v2 = parseInt(b[this.sortField]);
        if (v1 === v2) return 0;        
        return v1 > v2 ? 1 : -1;
      });

    return observable(this.sortDirection === SORT_ASC ? sortedItems : sortedItems.reverse());
  }

  @computed get shownItems() {
    return this.sortedItems.slice(this.pager.firstShownItem - 1, this.pager.lastShownItem + 1);
  }

  @observable palletHistory;
  @action setPalletHistory(value) {
    this.palletHistory = value;
  }
}

export { DatabaseStore, STORE_DATABASE };